export enum BaseLanguage {
  en = 'en',
  de = 'de',
}
